import Vue from 'vue'
import template from './_unregister-box.pug'

const UnregisterReasons = ['other_city', 'not_public_transport', 'not_useful', 'not_work', 'other']

export default Vue.extend({
  template: template(),
  data() {
    return {
      unregisterReason: null,
      explanation: '',
      errorReason: null,
      errorExplanation: null
    }
  },
  computed: {
    unregisterReasonOptions() {
      return UnregisterReasons.map(reason => ({
        label: this.$t(`profile.unregister.reason.options.${reason}`,
          {web_title: Vue.store.state.webTitle}),
        value: reason
      }))
    },

    hasNotErrors() {
      return _.isEmpty(this.errorReason) && _.isEmpty(this.errorExplanation)
    },

    reasonIsOther() {
      return this.unregisterReason === 'other'
    }
  },
  watch: {
    unregisterReason(newVal, oldVal) {
      if (!_.isEqual(newVal, oldVal)) this.cleanErrors()
    }
  },
  methods: {
    submit() {
      this.calculateErrors()

      if (this.hasNotErrors) this.unregisterCurrentUser()
    },

    calculateErrors() {
      this.cleanErrors()

      if (this.reasonIsOther && this.explanation === '') {
        this.errorExplanation = this.$t('profile.unregister.reason.errorExplanation')
      } else if (this.unregisterReason === null) {
        this.errorReason = this.$t('profile.unregister.reason.error')
      }
    },

    cleanErrors() {
      this.errorExplanation = null
      this.errorReason = null
    },

    unregisterCurrentUser() {
      const params = {
        data: {
          reason: this.unregisterReason,
          explanation: this.explanation
        }
      }

      // Si acierta cerramos sesión y lo enviamos a la página de despedida
      this.$auth.unregister(params).then(() => {
        this.$auth.setToken('')
        this.$store.commit('setCurrentUser', null)

        this.$router.push({name: 'goodbye'})
      },

      // Si falla muestra un mensaje de error
      () => {
        this.$notifications.send({
          id: 'unregister-error',
          text: this.$t('profile.unregister.error'),
          type: 'error',
          close: true
        })
      })
    },

    cancel() {
      this.$emit('close-unregister-box')
    }
  }
})
